import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import "./LoginScreen.css";
import logo from "../cryptomania.svg";
import { serverColorBg } from "../constants";
import { initGoogleSignInButton } from "../auth";

@inject("store")
@observer
class App extends Component {
  componentDidMount() {
    initGoogleSignInButton();
  }

  render() {
    // const { store: { authStore: { initialized: authInitialized, loading: authLoading } } } = this.props;

    return (
      <div
        className="LoginScreen"
        style={{
          background: `radial-gradient(circle, white, ${serverColorBg})`,
        }}
      >
        <div className="LoginScreen-Content">
          <img src={logo} alt="Logo" className="LoginScreen-Logo" />
          <br />
          <div id="btnGoogleSignIn" className="LoginScreen-LoginButtonHolder" />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/screens/LoginScreen.js